var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M366.667 500C337.277 500 309.364 493.66 284.227 482.273C266.81 474.383 258.101 470.437 253.266 469.073C248.24 467.657 245.328 467.143 240.12 466.753C235.11 466.38 231.36 466.667 223.858 467.24C220.79 467.473 218.083 467.803 215.519 468.267C174.481 475.697 142.362 507.813 134.933 548.853C133.333 557.687 133.333 568.283 133.333 589.47V646.667C133.333 665.337 133.333 674.67 136.966 681.8C140.162 688.073 145.262 693.17 151.534 696.367C158.664 700 167.998 700 186.667 700H280M500 233.333C500 306.971 440.303 366.667 366.667 366.667C293.029 366.667 233.333 306.971 233.333 233.333C233.333 159.695 293.029 100 366.667 100C440.303 100 500 159.695 500 233.333ZM419.66 700L487.16 686.5C493.047 685.323 495.99 684.733 498.733 683.657C501.17 682.703 503.483 681.463 505.63 679.967C508.047 678.28 510.17 676.16 514.413 671.913L652.993 533.333C671.403 514.923 671.403 485.077 652.993 466.667C634.587 448.257 604.737 448.257 586.327 466.667L447.747 605.247C443.503 609.493 441.38 611.613 439.693 614.033C438.197 616.177 436.96 618.493 436.003 620.93C434.927 623.673 434.34 626.617 433.16 632.5L419.66 700Z",
    stroke: "white",
    strokeWidth: 66.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.ac0129ea2a9683aed961605e0636c528.svg";
export { ForwardRef as ReactComponent };